<template>
  <div>
    <apexchart
      ref="chart"
      type="bar"
      :options="chartOptions"
      :series="series"
      :width="width"
    />
  </div>
</template>

<script>
export default {
  name: 'GenericBarChart',

  props: {
    data: { type: Array, required: true },
    labelField: { type: String, default: 'key' },
    contractsField: { type: String, default: 'contracts' },
    amountField: { type: String, default: 'amount' },
    titleX: { type: String, default: 'Categoría' },
    width: { type: String, default: '100%' },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        colors: ['#4953CF', '#33C4C5'],
        chart: {
          stacked: false,
          toolbar: { show: true },
          zoom: { enabled: false },
        },
        plotOptions: {
          bar: { horizontal: false, columnWidth: '45%' },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: [],
          labels: { rotate: -45, show: false },
          title: { text: this.titleX },
        },
        yaxis: [
          {
            title: { text: 'Nº contratos' },
            labels: { formatter: v => Math.round(v) },
          },
          {
            opposite: true,
            title: { text: 'Importe (€)' },
            labels: {
              formatter(val) {
                if (val > 1e9) return `${(val / 1e9).toFixed(2)} B€`;
                if (val > 1e6) return `${(val / 1e6).toFixed(2)} M€`;
                return val.toLocaleString();
              },
            },
          },
        ],

        tooltip: {
          shared: true,
          intersect: false,
          y: {
            // eslint-disable-next-line consistent-return
            formatter(val) {
              if (val > 1e9) return `${(val / 1e9).toFixed(2)} B€`;
              if (val > 1e6) return `${(val / 1e6).toFixed(2)} M€`;
              return `${new Intl.NumberFormat('es-ES').format(Math.round(val))} €`;
            },
          },
        },

        legend: { position: 'top' },
      },
    };
  },

  mounted() {
    this.buildChart();
  },
  computed: {
    barColumnWidth() {
      const n = this.series
        && this.series[0]
        && this.series[0].data
        ? this.series[0].data.length
        : 0;

      if (n <= 3) return '8%';
      if (n <= 6) return '20%';
      return '45%';
    },
  },
  watch: {
    data: {
      handler() {
        this.buildChart();
      },
      deep: true,
    },
  },

  methods: {
    buildChart() {
      const labels = this.data.map(item => item[this.labelField]);
      const contracts = this.data.map(item => item[this.contractsField]);
      const amounts = this.data.map(item => item[this.amountField]);

      this.series = [
        { name: 'Contratos', type: 'column', data: contracts },
        { name: 'Importe (€)', type: 'column', data: amounts },
      ];

      this.chartOptions = {
        ...this.chartOptions,
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: this.barColumnWidth,
          },
        },
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: labels,
          title: { text: this.titleX },
        },
      };

      if (this.$refs.chart) {
        this.$refs.chart.updateOptions(this.chartOptions, false, true);
      }
    },
  },
};
</script>
